import React from "react"
import PropTypes from "prop-types"

import BadgeIcon from './BadgeIcon'
import Icon from '../app_components/Icon'
import StandardButton from '../app_components/StandardButton'
import StandardModal from '../app_components/StandardModal'
import { primitives } from '@lexody/design-tokens'

class ProfileBadgeSection extends React.Component {

  constructor(props) {
    super(props)

    const initialBadges = Array.isArray(props.initialBadges) ? props.initialBadges : []

    this.state = {
      buttonText: "Submit",
      badges: initialBadges,
      allBadges: [],
      showAllBadgesModal: false,
      loaded: initialBadges.length > 0,
    }

    this.renderBadges = this.renderBadges.bind(this)
    this.renderEmptyBadges = this.renderEmptyBadges.bind(this)
    this.showAllBadgesButton = this.showAllBadgesButton.bind(this)
    this.renderAllBadgesModal = this.renderAllBadgesModal.bind(this)
    this.openAllBadges = this.openAllBadges.bind(this)
    this.closeAllBadges = this.closeAllBadges.bind(this)
  }



  componentDidMount() {
    if (this.state.loaded) {
      return
    }

    let data = {
      user_id: this.props.userId
    }
    $.ajax({
      url: `../get_profile_badges`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          badges: JSON.parse(data.data.badges),
          allBadges: JSON.parse(data.data.allBadges),
          loaded: true,
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  isBadgeEarned(badge) {
    return this.state.badges.some((earned) => earned.id === badge.id)
  }

  openAllBadges() {
    this.setState({ showAllBadgesModal: true })
  }

  closeAllBadges() {
    this.setState({ showAllBadgesModal: false })
  }

  renderBadges() {
    return this.state.badges.map((badge, i) => {
      return <BadgeIcon badge={badge} key={badge.id || i} badgeEarned={true} closeIcon={this.props.closeIcon}/>
    })
  }

  renderAllBadges() {
    return this.state.allBadges.map((badge, i) => {
      return (
        <BadgeIcon
          badge={badge}
          key={badge.id || i}
          badgeEarned={this.isBadgeEarned(badge)}
          closeIcon={this.props.closeIcon}
        />
      )
    })
  }

  renderEmptyBadges(badgeCount) {
    let count = 8 - badgeCount % 8;
    let placeholders = []

    for(let i = 0; i < count; i++){
        placeholders.push(
            <div className="profile-badges__placeholder" key={i} aria-hidden="true" />
        )
    }
    return placeholders

  }

  renderAllBadgesPlaceholders() {
    const remainder = this.state.allBadges.length % 4;
    const count = remainder === 0 ? 0 : 4 - remainder;
    const placeholders = []

    for(let i = 0; i < count; i++){
        placeholders.push(
            <div className="profile-badges__placeholder" key={i} aria-hidden="true" />
        )
    }
    return placeholders
  }

  showAllBadgesButton() {
    if(this.props.dashboard === true) {
      return (
        <div className="profile-badges__toggle">
          <StandardButton
            primary
            size="large"
            fullWidth
            text="All Badges"
            onClick={this.openAllBadges}
          />
        </div>
      )
    }
    return null
  }

  renderAllBadgesModal() {
    if (!this.state.showAllBadgesModal) {
      return null
    }

    return (
      <StandardModal
        onClose={this.closeAllBadges}
        title="All Badges"
        modalClass="allBadgesModal"
      >
        <header className="profile-badges__header">
          <div className="profile-badges__titleRow">
            <span className="profile-badges__iconCircle" aria-hidden="true">
              <Icon name="award" size={20} color={primitives.violet['700']} />
            </span>
            <h2 className="profile-badges__title">All Badges</h2>
          </div>
        </header>
        <div className="profile-badges__grid allBadgesModal__grid">
          {this.renderAllBadges()}
          {this.renderAllBadgesPlaceholders()}
        </div>
      </StandardModal>
    )
  }

  render() {
    return(
      <section className="profile-badges">
        <header className="profile-badges__header">
          <div className="profile-badges__titleRow">
            <span className="profile-badges__iconCircle" aria-hidden="true">
              <Icon name="award" size={20} color={primitives.violet['700']} />
            </span>
            <h2 className="profile-badges__title">My Badges</h2>
          </div>
        </header>
        <div className="profile-badges__grid">
          {this.renderBadges()}
          {this.renderEmptyBadges(this.state.badges.length)}
        </div>
        {this.showAllBadgesButton()}
        {this.renderAllBadgesModal()}
      </section>
    )
  }

}


ProfileBadgeSection.propTypes = {
  userId: PropTypes.number.isRequired,
  dashboard: PropTypes.bool,
  closeIcon: PropTypes.string,
  initialBadges: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    body: PropTypes.string,
    image_url: PropTypes.string,
  })),
}

ProfileBadgeSection.defaultProps = {
  dashboard: false,
  initialBadges: [],
}

export default ProfileBadgeSection
